import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import GalleryPickerField from '../ChannelVideo/GalleryPickerField.js';
import 'react-toastify/dist/ReactToastify.css';
import ReactPlayer from 'react-player';
import ReactModal from 'react-modal';
import { useDispatch } from 'react-redux';
import { AiFillEdit, AiOutlineClose } from 'react-icons/ai';
import { ImCross } from 'react-icons/im';
import { AllChurchHooks } from "../../screens/Channel/hooks/channelhooks";
import {
  saveChurchVideoRequest,
  updateChurchVideoRequest,
  deleteChurchVideoRequest,
  readChurchVideoRequest
} from "../../store/ChurchVideos/ChurchVideoActions.js";


const VideoWithGallery = ({ church }) => {
  const [thumbnailImage, setThumbnailImage] = useState(null);
  const [isLive, setIsLive] = useState(false);
  const [isDefault, setIsDefault] = useState(false);
  const [galleryResetKey, setGalleryResetKey] = useState(Date.now());
  const [videos, setVideos] = useState([]);
  const [previewItem, setPreviewItem] = useState(null);
  const [editingVideo, setEditingVideo] = useState(null);

  const { fetchAllChurches } = AllChurchHooks();
  const dispatch = useDispatch();
  // --- Fetch Church Videos ---
  const GetChurch = () => {
    if (!church?._id) return;
    fetchAllChurches(
      1,
      9999,
      {},
      (res) => {
        const churchData = res?.data?.[0];

        if (churchData?.churchVideos?.length) {
          setVideos(churchData?.churchVideos);
        } else {
          setVideos([]);
        }
      },
      church._id
    );
  };

  useEffect(() => {
    GetChurch();
  }, [church?._id]);

  // --- Handle Thumbnail Selection ---
  const handleThumbSelect = (img) => {
    setThumbnailImage(img?.target?.value?.[0]?.id);
  };

  // --- Save or Update Video ---
  const handleSave = () => {
        if (!thumbnailImage) return toast.error("Select a video first!");
      const apiPayloadRequest = {
      _id: church._id,
      videoObjId: thumbnailImage,
      live: isLive,
      default: isDefault,
      ...(editingVideo && { churchvideoObjId: editingVideo.churchvideoObjId })
    };

    const action = editingVideo
      ? updateChurchVideoRequest(apiPayloadRequest, afterSave)
      : saveChurchVideoRequest(apiPayloadRequest, afterSave);

    dispatch(action);
  };

  const afterSave = (res) => {
    if (res.type === 1) {
      setThumbnailImage(null);
      setIsLive(false);
      setIsDefault(false);
      setEditingVideo(null);
      setGalleryResetKey(Date.now());
    GetChurch();

      // loadVideos();
    }
  };


  // --- Delete Video ---
  const handleDelete = (video) => {
    if (!video?.video?._id) return toast.error("Invalid video!");

    const apiPayloadRequest = {
      _id: church._id,
      churchvideoObjId: video.churchvideoObjId,
      videoObjId: video.video._id,
    };

    dispatch(
      deleteChurchVideoRequest(apiPayloadRequest, (res) => {
        if (res.type === 1) {
          // toast.success("Video deleted!");
          GetChurch(); // Refresh list after delete
        } else {
          toast.error(res.error || "Failed to delete video!");
        }
      })
    );
  };


  // --- Edit Video ---
  const handleEdit = (video) => {
    setEditingVideo(video);
    setThumbnailImage(video.videoObjId);
    setIsLive(video.live || false);
    setIsDefault(video.default || false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <>
    {
      church?
    <div className="px-4 text-white">
      {/* FORM */}
      <div className='flex justify-end mb-4'>
        <button
          onClick={handleSave}
          className="text-yellowish border border-yellowish rounded-xl py-2 px-6 text-[12px] font-medium transition-all duration-200"
        >
          {editingVideo ? "Update Video" : "Save Video"}
        </button>
      </div>

      <GalleryPickerField
        key={galleryResetKey}
        label="Select Video"
        name="thumbnail"
        church={church}
        handleChange={handleThumbSelect}
        rowData={editingVideo}
      />

      <div className="flex items-center gap-4 mt-4">
        <input
          type="checkbox"
          id="liveCheckbox"
          className="w-4 h-4 cursor-pointer accent-yellowish appearance-none border border-gray-300 rounded-full checked:bg-yellow-500 checked:border-yellow-500"
          checked={isLive}
          onChange={(e) => setIsLive(e.target.checked)}
        />
        <label htmlFor="liveCheckbox" className="cursor-pointer select-none">
          Live
        </label>

        <input
          type="checkbox"
          id="defaultCheckbox"
          className="w-4 h-4 cursor-pointer accent-yellowish appearance-none border border-gray-300 rounded-full checked:bg-yellow-500 checked:border-yellow-500"
          checked={isDefault}
          onChange={(e) => setIsDefault(e.target.checked)}
        />
        <label htmlFor="defaultCheckbox" className="cursor-pointer select-none">
          Default
        </label>
      </div>

      {/* VIDEO GALLERY */}
      {videos.length > 0 && (
        <div className="flex flex-wrap gap-6 mt-8">
          {videos.map((vid) => {
            const thumb =
            vid?.video?.gallery?.imageUrl ||
              "https://placehold.co/600x400?text=Video+Thumbnail";
            const videoName = vid?.video?.videoName || "No Title";

            return (
              <div key={vid._id} className="relative group w-[180px]">
                {/* THUMBNAIL */}
                <div
                  className="w-[180px] h-[120px] rounded-lg overflow-hidden border border-gray-700 cursor-pointer relative"
                  onClick={() => setPreviewItem(vid)}
                >
                  <img
                    src={thumb}
                    alt={videoName}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 flex items-center justify-center bg-black/40">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-10 h-10 text-white"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M6.271 11.243 10.271 8 6.271 4.757z" />
                    </svg>
                  </div>
                </div>

                {/* TITLE */}
                <div className="mt-1 text-[12px] text-center w-full line-clamp-1">
                  {videoName}
                </div>

                {/* EDIT ICON */}
                <div className="absolute bottom-2 left-2 bg-black/50 p-1 rounded-full cursor-pointer">
                  <AiFillEdit
                    className="text-white w-4 h-4"
                    onClick={() => handleEdit(vid)}
                  />
                </div>

                {/* DELETE ICON */}
                <div className="absolute top-2 left-2 bg-black/50 p-1 rounded-full cursor-pointer">
                  <AiOutlineClose
                    className="text-white w-4 h-4"
                    onClick={() => handleDelete(vid)}
                  />
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* REACTPLAYER MODAL */}
      <ReactModal
        isOpen={!!previewItem}
        onRequestClose={() => setPreviewItem(null)}
        className="flex justify-center items-center h-full w-full bg-black/90"
      >
        <div className="relative p-4">
          <div
            className="absolute top-2 right-2 cursor-pointer"
            onClick={() => setPreviewItem(null)}
          >
            <ImCross className="text-white w-6 h-6" />
          </div>

          <ReactPlayer
            url={previewItem?.video?.youtubeurl}
            controls
            playing
            width="800px"
            height="450px"
          />
        </div>
      </ReactModal>
    </div>
    :
    <div className="w-full h-full flex items-center justify-center text-gray-400 ">
    <p>Add Church/Ministry/Channel First</p>
    </div>
}
    </>
  );
};

export default VideoWithGallery;
